<template>
  <v-dialog
    v-model="sendSmsDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="50%"
    persistent
  >
    <v-card>
      <v-toolbar
        dark
        color="secondary"
        class="elevation-0"
      >
        <v-btn
          icon
          dark
          @click.native="sendSmsDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>שליחת sms</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="loading"
          :disabled="loading"
          @click="sendSms"
        >
          שליחה
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-select
          :items="smsTypes"
          label="סוג sms"
          item-text="title"
          item-value="_id"
          @input="setMessage"
          v-model="editable.smsType"
          clearable
        ></v-select>
        <v-select
          :items="customers"
          label="לקוח"
          item-text="name"
          item-value="_id"
          @input="setPhoneNumberField"
          v-model="editable.customer"
          clearable
        ></v-select>
        <v-text-field
          label="מספר טלפון"
          v-model="editable.phoneNumber"
          :disabled="!!editable.customer"
        ></v-text-field>
        <v-textarea label="תוכן ההודעה" v-model="editable.message">
          
        </v-textarea>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApi } from "@/api";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      loading: false,
      editable: {}
    };
  },

  computed: {
    sendSmsDialog: {
      get() {
        return this.$store.state.sendSmsDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_SEND_SMS_DIALOG", isActive);
      }
    },
    order() {
      return this.$store.state.entities.orders[this.orderId];
    },
    smsTypes() {
      return Object.values(this.$store.state.entities.smsTypes);
    },
    smsType() {
      if (this.editable.smsType) {
        return this.$store.state.entities.smsTypes[this.editable.smsType];
      }
      return null
    },
    customers() {
      let customers = [];
      if (this.order) {
        let traveler = this.customerById(this.order.traveler);
        let payer = this.customerById(this.order.payer);
        if (traveler) {
          customers.push(traveler);
        }
        if (payer) {
          customers.push(payer);
        }
      }
      return customers;
    }
  },

  methods: {
    sendSms() {
      this.loading = true;

      getApi()
        .then(api => {
          let params = {
            order: this.orderId,
            phoneNumber: this.editable.phoneNumber,
            message: this.editable.message
          };
          return api.post(
            `/sms-types/${this.editable.smsType}/send`,
            params
          );
        })
        .then(() => {
          this.sendSmsDialog = false;
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "ההודעה נשלחה בהצלחה",
            color: "success"
          });
        })
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initEditableResource() {
      this.editable = {
        customer: null,
        smsType: null,
        phoneNumber: null,
        message: ''
      };
    },
    customerById(id) {
      return this.$store.state.entities.customers[id];
    },
    smsTypeById(id) {
      return this.$store.state.entities.smsTypes[id];
    },
    setPhoneNumberField(customerId) {
      if (customerId) {
        let customer = this.customerById(customerId);
        if (customer) {
          let phoneNumber = customer.phone;
          if (phoneNumber) {
            this.editable.phoneNumber = phoneNumber;
          } else {
            this.editable.phoneNumber = "";
            this.showError(new Error("לא הוזן מספר טלפון ללקוח"));
          }
        }
      }
    },
    setMessage(smsTypeId) {
      if (smsTypeId) {
        let smsType = this.smsTypeById(smsTypeId);
        if (smsType) {
          let message = smsType.message;
          if (message) {
            this.editable.message = message;
          }
        }
      }
    }
  },

  mounted() {
    this.initEditableResource();
  },

  props: ["orderId"],

  mixins: [Mixins],

  watch: {
    sendSmsDialog: {
      handler: function(val) {
        if (!val) {
          this.initEditableResource();
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
